import React from "react";
import "./SectionContainer.css";

type SectionContainerProps = {
  children: React.ReactNode;

  /** Optional section id for anchor links */
  id?: string;

  /** If true, renders as a card surface */
  card?: boolean;

  /** Optional extra className */
  className?: string;
};

function cls(...parts: Array<string | false | null | undefined>) {
  return parts.filter(Boolean).join(" ");
}

const SectionContainer: React.FC<SectionContainerProps> = ({
  children,
  id,
  card = true,
  className,
}) => {
  return (
    <section
      id={id}
      className={cls(
        "ocf-pi-section",
        card && "ocf-pi-section--card",
        className
      )}
    >
      <div className="ocf-pi-section-inner">{children}</div>
    </section>
  );
};

export default SectionContainer;
